export const ProjectName = "sflinsights";
export const basename = "sflinsights";

//app server

export const HOST_URL = "https://dev.sflhub.com/sflconnectapi/"; // shipment module
export const baseURL = "https://dev.sflhub.com/sflinsightandOrdermngt"; //order management

export const WEB_URL = "https://dev.sflhub.com/sflinsights";
export const shipment_enquiry_mail = "connectwithus@softfreightlogic.com";
export const default_whatsapp_no = "+918130552650";
//dev server

// export const WEB_URL = "http://dev.sflhub.com/sflinsights";
// export const HOST_URL = "https://dev.sflhub.com/sflconnectapi/";

export const version = "1.2.0";
export const LOCAL_STORAGE_KEY = {
  user_token: "OrderUserDataLogin",
};
